import '../../css/modules/numbered_list_of_texts.css';

export class NumberedListOfTexts {

  constructor() {

  }

}